import axios from 'axios'
import { ACCOUNTS_API, WITH_CREDENTIALS_CONFIG } from './constants'

export const searchAccounts = (searchTerm: string) =>
  axios.get(
    `${ACCOUNTS_API}?q=${encodeURIComponent(searchTerm)}`,
    WITH_CREDENTIALS_CONFIG
  )

export const getAccountDetails = (accountNumber: string) =>
  axios.get(`${ACCOUNTS_API}/${accountNumber}`, WITH_CREDENTIALS_CONFIG)

export const getAccountOwners = (accountNumber: string) =>
  axios.get(`${ACCOUNTS_API}/${accountNumber}/owners`, WITH_CREDENTIALS_CONFIG)
